unit unit_Kontaktnummersuche;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Data.DB, WEBLib.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, XData.Web.Connection, Vcl.Controls, Vcl.StdCtrls,
  WEBLib.StdCtrls, WEBLib.ExtCtrls, Vcl.Grids, WEBLib.DBCtrls, VCL.TMSFNCTypes,
  VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, strutils,
  VCL.TMSFNCCustomControl, VCL.TMSFNCTableView, WEBLib.Grids, WEBLib.Buttons, DB;

type
  TfrmKontaktNummerSuche = class(TForm)
    DataSet: TXDataWebDataSet;
    Source: TDataSource;
    DataSetKundennummer: TStringField;
    DataSetNachname: TStringField;
    DataSetVorname: TStringField;
    DataSetAdresseBild: TStringField;
    Container1: THTMLContainer;
    Container2: THTMLContainer;
    Container3: THTMLContainer;
    TC: TTableControl;
    btnzurueck: TButton;
    btnScan: TButton;
    edtSuchbegriff: TEdit;
    ResultLabel: TLabel;
    procedure WebFormShow(Sender: TObject);
    procedure DataSetAfterOpen(DataSet: TDataSet);
    procedure btnzurueckClick(Sender: TObject);
    procedure btnScanClick(Sender: TObject);
    procedure edtSuchbegriffChange(Sender: TObject);

    public
    Kontaktnummer:string;
    LUNachname:string;
    LUVorname:string;
    LUAdressebild:string;
    weiterzuEinzelkontakt:boolean;
    buttonkundennummer:TButton;
    procedure buttonkundennummerclick(Sender:TObject);
  protected procedure LoadDFMValues; override; end;

var
  frmKontaktNummerSuche: TfrmKontaktNummerSuche;

implementation
  uses unit1, unit2, unit_EinzelKontakt, unit_BarcodeScan;
{$R *.dfm}


procedure TfrmKontaktNummerSuche.btnScanClick(Sender: TObject);
var
  LFrm:TBarcodeScan;
  procedure AfterCreate(AForm:TObject);
  var
    LForm:TBarcodeScan;
    begin
      LForm:=(AForm as TBarcodeScan);
      //lform.mykundehint:=xdsEinzelkontaktKundennummer.AsString+' '+xdsEinzelkontaktNachname.AsString+', '+xdsEinzelkontaktVorname.asstring;
      //lForm.edttoaddress.Text:= xdsEinzelkontaktPostleitzahl.AsString+' '+xdsEinzelkontaktort.AsString+', '+xdsEinzelkontaktStrasse.AsString;

    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      edtsuchbegriff.text:=lfrm.ScanErgebnis;
      edtsuchbegriffChange(self);
    end;
  begin
    if LizenzOK then
    begin
      LFrm:=TBarcodeScan.CreateNew(@AfterCreate);
      LFrm.ShowModal(@AfterShowmodal);
    end
    else
    begin
      showmessage('Für diese Funktion sind Sie noch nicht freigeschaltet, bitte erwerben Sie eine Lizenz');
    end;

end;

procedure TfrmKontaktNummerSuche.btnzurueckClick(Sender: TObject);
begin
  self.Close;
end;

procedure TfrmKontaktNummerSuche.buttonkundennummerclick(Sender:TObject);
var
  MFrm:TEinzelkontakt;
    procedure AfterCreate(AForm:TObject);
    var
      MForm:TEinzelkontakt;
    begin
      MForm:=(AForm as TEinzelkontakt);
      MForm.KundennummerID:=Kontaktnummer;
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      edtsuchbegriffChange(nil);
    end;

  begin

  Kontaktnummer:=(sender as TButton).Caption;
  dataset.Locate('Kundennummer',kontaktnummer,[]);
  LUNachname:=DataSetNachname.AsString;
  LUVorname:=DataSetVorname.AsString;
  LUAdressebild:=DataSetAdresseBild.AsString;
  if weiterzueinzelkontakt then
  begin
    Container3.HTML.Text:='';
    MFrm:=TEinzelkontakt.CreateNew(@AfterCreate);
    MFrm.ShowModal(@AfterShowmodal);
  end
  else
  begin
    self.Close;
  end;
end;



procedure TfrmKontaktNummerSuche.DataSetAfterOpen(DataSet: TDataSet);
var
  i:integer;
  myelement:TJSHTMLElement;
begin
  myelement:=container3.ElementHandle;
  tc.ParentElement:=myelement;
  i:=0;
  TC.visible:=true;
  TC.ColCount:=4;
  tc.RowCount:=dataset.RecordCount+1;
  tc.Cells[0,i]:='<b>Kundennummer';
  tc.Cells[1,i]:='<b>Nachname';
  tc.Cells[2,i]:='<b>Vorname';
  tc.Cells[3,i]:='<b>Anschrift';
  dataset.First;
  if dataset.RecordCount=0 then resultlabel.Caption:='nichts gefunden';
  if dataset.RecordCount>0 then resultlabel.Caption:='Übereinstimmungen: '+inttostr(dataset.RecordCount);
  if dataset.RecordCount>20 then resultlabel.Caption:='mehr als 20 Übereinstimmungen';

  while not dataset.eof do
  begin
    inc(i);
    myelement:=TC.cellelements[0,i];
    myelement.innerHTML:='';
    buttonkundennummer:=TButton.Create(self);
    buttonkundennummer.ElementClassName:='btn btn-sm btn-info';
    buttonkundennummer.HeightStyle:=ssauto;
    buttonkundennummer.Width:=150;
    buttonkundennummer.tag:=0;
    buttonkundennummer.Caption:=DataSetKundennummer.AsString;
    buttonkundennummer.OnClick:=@buttonkundennummerClick;
    buttonkundennummer.ParentElement:=myelement;
    TC.Cells[1,i]:=DataSetNachname.AsString;
    TC.Cells[2,i]:=DataSetVorname.AsString;
    TC.Cells[3,i]:='<h6>'+ReplaceStr(DataSetAdresseBild.AsString,#13+#10,'<BR>');;
    dataset.Next;
  end;

end;



procedure TfrmKontaktNummerSuche.edtSuchbegriffChange(Sender: TObject);
var
  suchtextkontakt:string;
begin
  suchtextkontakt:=edtsuchbegriff.Text;
  if length(suchtextkontakt)>0 then
  begin
  dataset.Close;
  dataset.QueryString:='$filter= Kundennummer eq '+quotedstr(edtsuchbegriff.Text);
  dataset.Load;
  end;

end;

procedure TfrmKontaktNummerSuche.WebFormShow(Sender: TObject);
var
  myelement:TJSHTMLElement;
begin
  Container1.html.text:='<nav class="navbar m-1 rounded bg-info"><h5>Kontaktsuche</h5></nav>';
  myelement:=container1.ElementHandle;
  btnzurueck.ParentElement:=myelement;
  btnscan.ParentElement:=myelement;
  container2.ParentElement:=myelement;
  Container3.ParentElement:=myelement;
  myelement:=container2.ElementHandle;
  resultlabel.Caption:='Kundennummer';
  resultlabel.ParentElement:=myelement;
  edtsuchbegriff.ParentElement:=myelement;
  TC.Visible:=false;
  Kontaktnummer:='';
  edtsuchbegriff.SetFocus;
end;

procedure TfrmKontaktNummerSuche.LoadDFMValues;
begin
  inherited LoadDFMValues;

  ResultLabel := TLabel.Create(Self);
  Container1 := THTMLContainer.Create(Self);
  Container2 := THTMLContainer.Create(Self);
  Container3 := THTMLContainer.Create(Self);
  TC := TTableControl.Create(Self);
  btnzurueck := TButton.Create(Self);
  btnScan := TButton.Create(Self);
  edtSuchbegriff := TEdit.Create(Self);
  DataSet := TXDataWebDataSet.Create(Self);
  DataSetKundennummer := TStringField.Create(Self);
  DataSetNachname := TStringField.Create(Self);
  DataSetVorname := TStringField.Create(Self);
  DataSetAdresseBild := TStringField.Create(Self);
  Source := TDataSource.Create(Self);

  ResultLabel.BeforeLoadDFMValues;
  Container1.BeforeLoadDFMValues;
  Container2.BeforeLoadDFMValues;
  Container3.BeforeLoadDFMValues;
  TC.BeforeLoadDFMValues;
  btnzurueck.BeforeLoadDFMValues;
  btnScan.BeforeLoadDFMValues;
  edtSuchbegriff.BeforeLoadDFMValues;
  DataSet.BeforeLoadDFMValues;
  DataSetKundennummer.BeforeLoadDFMValues;
  DataSetNachname.BeforeLoadDFMValues;
  DataSetVorname.BeforeLoadDFMValues;
  DataSetAdresseBild.BeforeLoadDFMValues;
  Source.BeforeLoadDFMValues;
  try
    Name := 'frmKontaktNummerSuche';
    Width := 223;
    Height := 376;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    ResultLabel.SetParentComponent(Self);
    ResultLabel.Name := 'ResultLabel';
    ResultLabel.Left := 114;
    ResultLabel.Top := 231;
    ResultLabel.Width := 60;
    ResultLabel.Height := 15;
    ResultLabel.Caption := 'ResultLabel';
    ResultLabel.ElementClassName := 'h6 m-2';
    ResultLabel.ElementFont := efCSS;
    ResultLabel.ElementPosition := epIgnore;
    ResultLabel.HeightStyle := ssAuto;
    ResultLabel.HeightPercent := 100.000000000000000000;
    ResultLabel.WidthStyle := ssPercent;
    ResultLabel.WidthPercent := 100.000000000000000000;
    Container1.SetParentComponent(Self);
    Container1.Name := 'Container1';
    Container1.Left := 0;
    Container1.Top := 0;
    Container1.Width := 169;
    Container1.Height := 41;
    Container1.HeightStyle := ssAuto;
    Container1.WidthStyle := ssPercent;
    Container1.ElementFont := efCSS;
    Container1.ElementPosition := epIgnore;
    Container2.SetParentComponent(Self);
    Container2.Name := 'Container2';
    Container2.Left := 0;
    Container2.Top := 47;
    Container2.Width := 169;
    Container2.Height := 41;
    Container2.ElementClassName := 'd-flex flex-wrap m-1 border border-info';
    Container2.HeightStyle := ssAuto;
    Container2.WidthStyle := ssAuto;
    Container2.ChildOrder := 1;
    Container2.ElementFont := efCSS;
    Container2.ElementPosition := epIgnore;
    Container3.SetParentComponent(Self);
    Container3.Name := 'Container3';
    Container3.Left := 0;
    Container3.Top := 94;
    Container3.Width := 169;
    Container3.Height := 41;
    Container3.ElementClassName := 'd-flex m-1';
    Container3.HeightStyle := ssAuto;
    Container3.WidthStyle := ssAuto;
    Container3.ChildOrder := 2;
    Container3.ElementFont := efCSS;
    Container3.ElementPosition := epIgnore;
    TC.SetParentComponent(Self);
    TC.Name := 'TC';
    TC.Left := 0;
    TC.Top := 141;
    TC.Width := 169;
    TC.Height := 79;
    TC.ElementClassName := 'table table-hover table-bordered table-striped';
    TC.HeightStyle := ssAuto;
    TC.WidthStyle := ssPercent;
    TC.BorderColor := clSilver;
    TC.ChildOrder := 3;
    TC.ColHeader := False;
    TC.ElementFont := efCSS;
    TC.ElementHeaderClassName := 'table-info';
    TC.ElementPosition := epIgnore;
    TC.ElementTableClassName := 'table table-hover table-bordered table-striped';
    TC.WordWrap := True;
    TC.ColCount := 1;
    TC.RowCount := 5;
    btnzurueck.SetParentComponent(Self);
    btnzurueck.Name := 'btnzurueck';
    btnzurueck.Left := 0;
    btnzurueck.Top := 226;
    btnzurueck.Width := 96;
    btnzurueck.Height := 25;
    btnzurueck.Caption := '<< zur'#252'ck';
    btnzurueck.ChildOrder := 4;
    btnzurueck.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnzurueck.ElementFont := efCSS;
    btnzurueck.ElementPosition := epIgnore;
    btnzurueck.HeightStyle := ssAuto;
    btnzurueck.HeightPercent := 100.000000000000000000;
    btnzurueck.WidthStyle := ssAuto;
    btnzurueck.WidthPercent := 100.000000000000000000;
    SetEvent(btnzurueck, Self, 'OnClick', 'btnzurueckClick');
    btnScan.SetParentComponent(Self);
    btnScan.Name := 'btnScan';
    btnScan.Left := 0;
    btnScan.Top := 257;
    btnScan.Width := 96;
    btnScan.Height := 25;
    btnScan.Caption := 'Bar-/QR-Code scannen';
    btnScan.ChildOrder := 4;
    btnScan.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnScan.ElementFont := efCSS;
    btnScan.ElementPosition := epIgnore;
    btnScan.HeightStyle := ssAuto;
    btnScan.HeightPercent := 100.000000000000000000;
    btnScan.WidthStyle := ssAuto;
    btnScan.WidthPercent := 100.000000000000000000;
    SetEvent(btnScan, Self, 'OnClick', 'btnScanClick');
    edtSuchbegriff.SetParentComponent(Self);
    edtSuchbegriff.Name := 'edtSuchbegriff';
    edtSuchbegriff.Left := 8;
    edtSuchbegriff.Top := 296;
    edtSuchbegriff.Width := 150;
    edtSuchbegriff.Height := 22;
    edtSuchbegriff.ChildOrder := 6;
    edtSuchbegriff.ElementClassName := 'form-control input-sm m-1';
    edtSuchbegriff.ElementFont := efCSS;
    edtSuchbegriff.ElementPosition := epIgnore;
    edtSuchbegriff.HeightStyle := ssAuto;
    edtSuchbegriff.HeightPercent := 100.000000000000000000;
    edtSuchbegriff.ShowHint := True;
    edtSuchbegriff.TextHint := 'Suchbegriff eingeben';
    edtSuchbegriff.WidthPercent := 60.000000000000000000;
    SetEvent(edtSuchbegriff, Self, 'OnChange', 'edtSuchbegriffChange');
    DataSet.SetParentComponent(Self);
    DataSet.Name := 'DataSet';
    DataSet.AfterOpen := DataSetAfterOpen;
    DataSet.EntitySetName := 'Adressen';
    DataSet.Connection := DM2.XDataWebConnection1;
    DataSet.QueryTop := 20;
    DataSet.Left := 8;
    DataSet.Top := 56;
    DataSetKundennummer.SetParentComponent(DataSet);
    DataSetKundennummer.Name := 'DataSetKundennummer';
    DataSetKundennummer.FieldName := 'Kundennummer';
    DataSetKundennummer.Required := True;
    DataSetKundennummer.Size := 13;
    DataSetNachname.SetParentComponent(DataSet);
    DataSetNachname.Name := 'DataSetNachname';
    DataSetNachname.FieldName := 'Nachname';
    DataSetNachname.Required := True;
    DataSetNachname.Size := 40;
    DataSetVorname.SetParentComponent(DataSet);
    DataSetVorname.Name := 'DataSetVorname';
    DataSetVorname.FieldName := 'Vorname';
    DataSetVorname.Size := 40;
    DataSetAdresseBild.SetParentComponent(DataSet);
    DataSetAdresseBild.Name := 'DataSetAdresseBild';
    DataSetAdresseBild.FieldName := 'AdresseBild';
    DataSetAdresseBild.Size := 255;
    Source.SetParentComponent(Self);
    Source.Name := 'Source';
    Source.DataSet := DataSet;
    Source.Left := 56;
    Source.Top := 56;
  finally
    ResultLabel.AfterLoadDFMValues;
    Container1.AfterLoadDFMValues;
    Container2.AfterLoadDFMValues;
    Container3.AfterLoadDFMValues;
    TC.AfterLoadDFMValues;
    btnzurueck.AfterLoadDFMValues;
    btnScan.AfterLoadDFMValues;
    edtSuchbegriff.AfterLoadDFMValues;
    DataSet.AfterLoadDFMValues;
    DataSetKundennummer.AfterLoadDFMValues;
    DataSetNachname.AfterLoadDFMValues;
    DataSetVorname.AfterLoadDFMValues;
    DataSetAdresseBild.AfterLoadDFMValues;
    Source.AfterLoadDFMValues;
  end;
end;

end.
